import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Signed in");
      navigate(location.state?.from || "/dashboard");
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <Card className="border-2 border-gray-900 rounded-xl">
        <CardContent className="p-8">
          <h1 className="font-heading text-3xl font-bold text-gray-900">Welcome back</h1>
          <p className="mt-2 text-gray-700">Log in to nominate, inspect or manage venues.</p>
          <form onSubmit={onSubmit} className="mt-8 space-y-5">
            <div>
              <Label htmlFor="email" className="text-lg font-medium">Email</Label>
              <Input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)}
                     className="mt-2 h-12 border-2 border-gray-300 focus:border-blue-600" data-testid="login-email"/>
            </div>
            <div>
              <Label htmlFor="password" className="text-lg font-medium">Password</Label>
              <Input id="password" type="password" required value={password} onChange={e => setPassword(e.target.value)}
                     className="mt-2 h-12 border-2 border-gray-300 focus:border-blue-600" data-testid="login-password"/>
            </div>
            <Button type="submit" disabled={loading} className="w-full h-12 rounded-full bg-blue-600 hover:bg-blue-700" data-testid="login-submit">
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
          <div className="mt-6 flex items-center justify-between text-sm">
            <Link to="/forgot" className="text-blue-700 font-medium hover:underline" data-testid="forgot-link">Forgot password?</Link>
            <Link to="/register" className="text-gray-700 hover:text-blue-700">No account? <span className="text-blue-700 font-medium">Create one</span></Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
